export function escapeHtml(value = '') {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function linkifyText(value = '') {
  const escaped = escapeHtml(value)
  const withBreaks = escaped.replace(/\n/g, '<br>')
  return withBreaks.replace(
    /(https?:\/\/[^\s<]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
  )
}

export function formatRelativeTime(value) {
  if (!value) {
    return ''
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return ''
  }

  const diffMs = Date.now() - date.getTime()
  const diffMinutes = Math.floor(diffMs / 60000)
  if (diffMinutes < 1) {
    return 'Just now'
  }
  if (diffMinutes < 60) {
    return `${diffMinutes}m`
  }

  const diffHours = Math.floor(diffMinutes / 60)
  if (diffHours < 24) {
    return `${diffHours}h`
  }

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric'
  })
}

export function truncatePreview(value = '', maxLen = 80) {
  const normalized = String(value).replace(/\s+/g, ' ').trim()
  if (!normalized) {
    return 'No messages yet'
  }
  if (normalized.length <= maxLen) {
    return normalized
  }
  return `${normalized.slice(0, maxLen - 1)}…`
}

export function channelMeta(prospect = {}) {
  const channel = String(prospect.messageChannel || prospect.socialPlatform || '').toUpperCase()
  if (channel.includes('FB') || channel.includes('FACEBOOK') || prospect.socialPlatform === 'facebook') {
    return { icon: 'fab fa-facebook-messenger', color: '#0084ff', label: 'Messenger' }
  }
  if (channel.includes('IG') || channel.includes('INSTAGRAM') || prospect.socialPlatform === 'instagram') {
    return { icon: 'fab fa-instagram', color: '#E1306C', label: 'Instagram' }
  }
  if (channel.includes('SMS')) {
    return { icon: 'fas fa-sms', color: '#50cd89', label: 'SMS' }
  }
  if (channel.includes('EMAIL')) {
    return { icon: 'fas fa-envelope', color: '#7239ea', label: 'Email' }
  }
  if (channel.includes('WEB')) {
    return { icon: 'fas fa-comment-dots', color: '#009ef7', label: 'Web Chat' }
  }
  return { icon: 'fas fa-comment', color: '#7e8299', label: 'Chat' }
}

export function isOutgoingRole(role) {
  return role === 'assistant' || role === 'human'
}

export function messageKey(message) {
  if (!message) {
    return ''
  }
  if (message.messageId) {
    return `mid:${message.messageId}`
  }
  if (message.id) {
    return `id:${message.id}`
  }
  return `tmp:${message.role}:${message.content}:${message.createdAt}`
}
